module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vmusc17-205762ae13dda565a5503a682506ae37.jpg";